<script>
import options from './BurgerMenu.options'
export default options
</script>

<template>
  <nav ref="burgerMenuRef" class="kb-burger-menu" :class="{ 'kb-burger-menu--simple': isSimple }" aria-label="hovednavigation">
    <div class="kb-burger-menu__content">
      <h2 class="kb-burger-menu__title">{{ getLabel('burgerMenuTitle') }}</h2>

      <div class="kb-burger-menu__primary-links">

        <template v-if="!isSimple">
          <ul class="kb-burger-menu__primary-links__column">
            <template v-for="(link, linkindex) in linkData.primary" :key="linkindex">
              <li v-if="link.column == 1">
                <PrimaryLink :link="link" :tabTrap="tabTrap" />
              </li>
            </template>
          </ul>
          <ul class="kb-burger-menu__primary-links__column">
            <template v-for="(link, linkindex) in linkData.primary" :key="linkindex">
              <li v-if="link.column == 2">
                <PrimaryLink :link="link" :tabTrap="tabTrap" />
              </li>
            </template>
          </ul>
        </template>

        <template v-else>
          <ul class="kb-burger-menu__primary-links__column">
            <template v-for="(link, linkindex) in linkData.primary" :key="linkindex">
              <li>
                <PrimaryLink :link="link" :tabTrap="tabTrap" />
              </li>
            </template>
          </ul>
        </template>

      </div>

      <div class="kb-burger-menu__bottom-section">

        <ul class="kb-burger-menu__secondary-links">
          <template v-for="(link, linkindex) in linkData.secondary" :key="linkindex">
            <li>
              <SecondaryLink :link="link" :tabTrap="tabTrap" />
            </li>
          </template>
        </ul>

        <template v-if="showFunctionalButtons">
          <div class="kb-burger-menu__functional-buttons">
            <a href="" class="kb-button">
              Log ind
              <div class="kb-ui-icon kb-ui-icon--ui-profile"></div>
            </a>
            <a href="" class="kb-button kb-button--full-color" @keydown.tab="tabTrap">
              Webshop
              <div class="kb-ui-icon kb-ui-icon--ui-shoppingcart"></div>
            </a>
          </div>
        </template>

        <template v-if="isSimple && linkData.simpleCta">
          <a :href="linkData.simpleCta.href" class="kb-button kb-button--full-color-spot"
            @keydown.tab="tabTrap">
            {{ linkData.simpleCta.text }}
          </a>
        </template>
      </div>
    </div>
    <template v-if="showReturnLink">
      <a href="https://www.cancer.dk/" class="kb-burger-menu__parent-link" @keydown.tab="tabTrap">
        <div class="kb-burger-menu__parent-link-item">
          <svg role="presentation" width="6" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.167 1 4.79 5 1.167 9" stroke="#3C3C3C" stroke-linejoin="round" />
          </svg>
          Til cancer.dk
        </div>
      </a>
    </template>
  </nav>
</template>
